// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames not based on template
	if (chunkId === 384) return "static/chunks/384.f77d8d1484a3677a.js";
	if (chunkId === 210) return "static/chunks/210.afe0f0b3cbe5ca34.js";
	if (chunkId === 496) return "static/chunks/graphql-print.83edc8afc0370428.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"225":"57671f315ae3f6d7","484":"26ab3b93c2bfa1d9","926":"27662b2edbad4bd4","997":"032401bc8ab7a78e"}[chunkId] + ".js";
};